import { render } from "./GuardadoSatisfactorioView.vue?vue&type=template&id=16c58b1c"
import script from "./GuardadoSatisfactorioView.vue?vue&type=script&lang=js"
export * from "./GuardadoSatisfactorioView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__